import { compare as jsonPatchCompare, applyPatch as jsonPatchApplyPatch, Operation } from 'fast-json-patch'
import { isArray, isUndefined, omitBy } from 'lodash'

/**
 * Compares two objects or arrays and generates an array of JSON Patch operations.
 * When comparing objects, undefined values are automatically omitted from the source object.
 */
export function compare<TFrom extends object | unknown[], TTo extends object | unknown[]>(from: TFrom, to: TTo): Operation[] {
    if (typeof from === 'object' && !isArray(from)) {
        return jsonPatchCompare(omitBy(from, isUndefined), to)
    }

    return jsonPatchCompare(from, to)
}

type JsonPatchApplyParameters = Parameters<typeof jsonPatchApplyPatch>

/**
 * Applies JSON Patch operations to a document.
 * Sets mutateDocument to false to avoid unexpectedly mutating objects.
 */
export function applyPatch<TDocument>(
    document: TDocument,
    patch: JsonPatchApplyParameters[1],
    validateOperation?: JsonPatchApplyParameters[2],
    banPrototypeModifications?: JsonPatchApplyParameters[3]
) {
    return jsonPatchApplyPatch(document, patch, validateOperation, false, banPrototypeModifications)
}
